import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "user/components/common/Header";
import OrderDetailItems from "./-components/OrderDetailItems";
import { useAuthStore } from "user/store/useAuthStore";
import { useGetOrderInfo } from "common/hooks/user/order/useGetOrderInfo";
import { SimpleOrderItem } from "./-components/OrderItem";
import { enum_api_uri } from "common/hooks/utils/enum";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";

export default function OrderCompleted() {
    const pageContainerRef = useRef<HTMLDivElement | null>(null);
    const { overlay, openOverlay, closeOverlay } = useOverlay();
    const navigate = useNavigate();
    const location = useLocation();
    const order_idx = location.state?.order_idx;
    const customer_idx = location.state?.customer_idx;
    const accessToken = useAuthStore(state => state.accessToken);
    const { data } = useGetOrderInfo(Number(order_idx) ?? 0);
    const recipient_info = data?.recipient_info;
    const product_info = data?.product_info;

    useEffect(() => {
        if (pageContainerRef.current) {
            pageContainerRef.current.scrollIntoView();
        }
    }, [pageContainerRef.current]);

    // console.log(data);

    return (
        <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
            <div className="min-h-[100dvh] bg-white" ref={pageContainerRef}>
                <Header
                    title="주문신청 완료"
                    onClickClose={() => {
                        navigate("/");
                    }}
                />
                {!accessToken && (
                    <div className="bg-[#F8F9F7] border-b-[8px] border-[#F3F3F8] py-[16px] text-[#4B632B] text-center">
                        입력하신 연락처로 주문 알림톡이 전송됩니다.
                    </div>
                )}

                <div className="wrapper py-[16px]">
                    <p className="text-[24px] leading-[36px] font-[500] text-center">
                        <span className="text-[#4B632B]">주문신청완료</span> 되었습니다.
                    </p>
                    <SimpleOrderItem
                        className="mt-[12px] mb-[16px]"
                        category={product_info?.product_category}
                        name={product_info?.product_name}
                        price={product_info?.product_amount}
                        img={
                            product_info?.product_image?.file_name
                                ? `${enum_api_uri.api_uri}/${product_info?.product_image?.file_name}`
                                : ""
                        }
                    />

                    <div className="flex gap-[8px]">
                        <button
                            type="button"
                            onClick={() => {
                                navigate("/new-order", { state: { reset: true, userData: { customer_idx } } });
                            }}
                            className="flex-1 border border-transparent text-white bg-[#273219] rounded-[12px] py-[12px] font-bold text-[18px] leading-[28px]"
                        >
                            다른 주문신청
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                const path = accessToken ? `/orders/${order_idx}` : `/orders/non-member/${order_idx}`;
                                navigate(path);
                            }}
                            className="flex-1 border border-[#dddddd] text-[#484964] rounded-[12px] py-[12px] font-bold text-[18px] leading-[28px]"
                        >
                            상세 주문내역
                        </button>
                    </div>
                </div>

                <OrderDetailItems
                    values={recipient_info}
                    orderDateFull={data?.order_date_full}
                    openOverlay={openOverlay}
                    closeOverlay={closeOverlay}
                />

                {accessToken && (
                    <div className="wrapper border-t-[8px] border-[#f3f3f8] py-[16px]">
                        <button
                            className="w-full py-[12px] border border-[#ddd] rounded-[12px] text-[#999] text-[18px] leading-[28px]"
                            onClick={() => navigate("/orders")}
                        >
                            목록으로
                        </button>
                    </div>
                )}
            </div>
        </OverlayWrapper>
    );
}
